import { render, staticRenderFns } from "./BottomButtonSaveSideBar.vue?vue&type=template&id=8ff854f6&"
import script from "./BottomButtonSaveSideBar.vue?vue&type=script&lang=js&"
export * from "./BottomButtonSaveSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports